import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import RolePrivateRoute from 'src/components/PrivateRotes/RolePrivateRoute';
import WithholdingsListView from './WithholdingsResume';

const WithholdingsView = () => (
  <Routes>
    <Route path="resume/*" element={<RolePrivateRoute component={WithholdingsListView} />} />
    <Route index element={<Navigate to="withholdings" replace />} />
  </Routes>
);

export default WithholdingsView;
